import { IntercomTrackEvent } from '../../../../../../shared/types/types';
import { logPageEvent } from '../../../../../../utils/analytics/eventLogger';

const logAnalytics = (trackEvent: IntercomTrackEvent, onboardingPage: string) => {
  logPageEvent(trackEvent, onboardingPage);
};

export default logAnalytics;
